module.exports = __webpack_public_path__ + "img/SketchPng852f00e4dbc4196bed1dc7cf7796ad489b8ffd268412989cdf500cb3b88a3181.ef1173b8.png";